import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createStructuredSelector } from 'reselect';
import { FormGroup, FormRow, FormItem } from '../../../common/components';
import BigButton from '../../components/BigButton';
import * as customer from '../../../modules/customer';

const CustomerSearchBox = ({ searchCriteria }) => {
    const disabled = searchCriteria.customerId.value ? "disabled": "";
    return (<div className="customerSearchBox">
        <div className="search-heading">
            <h3 className="search-title">
                Søk etter eksisterende kunde
            </h3>
            <div className="search-line">&nbsp;</div>
            <div className="clearfix"/>
        </div>
        
        <FormGroup>
            <FormRow>
                <FormItem id="customerId" label="Kunde ID" value={searchCriteria.customerId}/>
                <FormItem id="firstName" label="Fornavn" value={searchCriteria.firstName} disabled={disabled}/>
                <FormItem id="lastName" label="Etternavn" value={searchCriteria.lastName} disabled={disabled}/>
             </FormRow>
             <FormRow>
                <FormItem id="mobilePhone" label="Telefon" value={searchCriteria.mobilePhone} disabled={disabled}/>
                <FormItem id="email" label="E-post" value={searchCriteria.email} disabled={disabled}/>
                <FormItem id="deviceSerialNumber" label="SerialNumber" value={searchCriteria.deviceSerialNumber} disabled={disabled}/>
            </FormRow>
            <FormRow>
                <FormItem id="externalReference" label="Partner Kundenummer" value={searchCriteria.externalReference} disabled={disabled}/>
            </FormRow>
            {/*<FormRow>
                <FormItem id="birthdate" label="Fødselsdato" value={searchCriteria.birthDate} disabled={disabled}/>
                <FormItem id="hidden1" value={{}} label="hidden1" hidden={true} disabled={disabled}/>
                <FormItem id="hidden2" value={{}} label="hidden2" hidden={true} disabled={disabled}/>
            </FormRow>*/}
        </FormGroup>
    </div>);
};

CustomerSearchBox.propTypes = {
   searchCriteria: PropTypes.object.isRequired
} 

export default CustomerSearchBox;